<template>
  <div class="invoice-item">
    <div @click="incomeItemJump">
      <van-row :class="['context-wrap', 'income', !invoice.customRemark ? 'context-wrap-noborder' : ''].join(' ')">
        <van-col span="24" class="customer-name">
          <span class="title" v-if="invoice.sellerName">{{invoice.sellerName}}</span>
          <span class="title" v-if="invoice.place">地点：{{invoice.place}}</span>
          <span class="title" v-if="invoice.passengerName || invoice.stationGetOn">姓名：{{invoice.passengerName}}</span>
          <span class="money">¥{{convertNumber(invoice.amountWithTax)}}</span>
        </van-col>
        <van-col span="24" class="customer-name date"><span class="invoice-cube">{{renderInvoiceType(invoice.invoiceType)}}</span></van-col>
        <van-col span="24" class="customer-name date" v-if="invoice.stationGetOn">{{invoice.stationGetOn}}—{{invoice.stationGetOff}}</van-col>
        <van-col span="24" class="customer-name date" v-if="invoice.tag">{{invoice.tag || ''}} {{invoice.drewDate}}</van-col>
      </van-row>
      <van-row class="remark-wrap" v-if="invoice.customRemark">
        <p class="remark">
          {{invoice.customRemark || ' '}}
        </p>
      </van-row>
      <van-row class="btn-wrap" v-if="btnList.length">
        <van-button
          plain
          type="primary"
          size="normal"
          round
          v-for="(btn, index) in btnList"
          :key="index"
          v-on:click.stop="todo(findButton(btn).method, invoice)"
          :color="findButton(btn).color"
          class="btn-item"
        >
          {{findButton(btn).name}}
        </van-button>
      </van-row>
      <img class="invoice-tag" :src="getConfig(invoice).url" v-if="getConfig(invoice).url"/>
    </div>
  </div>
</template>

<script>
import {
  Row,
  Col,
  Button,
  Toast
} from 'vant'

import {
  renderTextWithConfig,
  getConfigWithText,
  ConvertNumber,
  isEmpty
} from '@utils/basicUtil'

import {
  INVOICE_TYPE_FOR_CARD_INCOME,
  INVOICE_STATUS_ICON
} from '@assets/config'
// import { invoiceRequest } from '@services'

const invoiceCardButtonType = [
  {
    name: '物流跟踪',
    method: 'express',
    color: '#2372FF'
  },
  {
    name: '',
    method: 'none',
    color: '#666666'
  }
]

export default {
  props: {
    invoice: {
      type: Object
    },
    type: {
      type: String
    },
    incomeJump: {
      type: Function
    },
    btnList: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    files: [],
    receiverInfo: {},
    invoiceVisible: false,
    detailData: {}
  }),
  mounted () {
  },
  methods: {
    convertNumber (num) {
      return ConvertNumber(num)
    },
    incomeItemJump () {
      this.$emit('incomeJump')
    },
    renderInvoiceType (text) {
      return renderTextWithConfig(text, INVOICE_TYPE_FOR_CARD_INCOME)
    },
    getConfig (item) {
      let key = ''
      if (item.checkFlag === 0) {
        if (item.invoiceType === '01' || item.invoiceType === '04' || item.invoiceType === '10' || item.invoiceType === '11') {
          key = 'invoice-checked-failed' // 验真失败
        }
      }
      if (item.checkFlag === 1 && item.commitFlag === 0) {
        key = 'invoice-checked' // 验真成功
      }
      if (item.checkFlag === 1 && item.commitFlag === 1) {
        key = 'invoice-un-send'
      }
      if (isEmpty(item.checkFlag)) { // 非增票
        if (item.commitFlag === 1) {
          key = 'invoice-un-send'
        }
      }
      if (item.logisticsStatus === 1) { // 待签收状态 全局可用
        key = 'invoice-un-receive'
      }
      if (item.logisticsStatus === 2) { // 待签收状态 全局可用
        key = 'invoice-submit'
      }
      // if (!item.checkFlag && !(item.invoiceType === '01' || item.invoiceType === '04' || item.invoiceType === '10' || item.invoiceType === '11')) {
      //   key = 'invoice-unchecked' // 未验真
      // }
      if (!key) {
        return ''
      }
      return getConfigWithText(key, INVOICE_STATUS_ICON)
    },
    findButton (text) {
      return invoiceCardButtonType.find(type => type.method === text)
    },
    todo (funName, invoice) {
      this[funName](invoice)
    },
    async express (invoice) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })

      Toast.clear()
      this.$router.push({
        path: '/message/express',
        query: {
          // invoiceId: invoice.id,
          // receiverAddress: invoice.receiverAddress,
          logisticsNo: invoice.logisticsNo,
          mobile: invoice.logisticsMobile,
          shipperCode: invoice.shipperCode
        }
      })
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Toast.name]: Toast
  }
}

</script>

<style lang="less" scoped src="./style.less"/>
